import { Agent, Address, BillingInformation } from './';

export class PaymentFormData {
    public policyNumber: string;
    public primaryTravelerName: string;
    public firstName: string;
    public lastName: string;
    public emailAddress: string;
    public address: Address;
    public billing: BillingInformation;
    public agent: Agent;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/payment-form-data.model.ts